import { Link } from 'react-router-dom';

export default function DJIRepairCenterSection() {
  const scrollToContact = () => {
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            IDS佐賀教習所はDJI推薦修理センターに認定
          </h2>
        </div>

        {/* DJI推薦修理センターとは */}
        <div className="bg-white rounded-2xl shadow-lg p-8 mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-6">
            DJI推薦修理センターとは
          </h3>
          <p className="text-gray-700 leading-relaxed mb-6">
            農業ドローン製品を所有するお客様へのサービス体験向上と、より効率的なサービス提供を目的として、DJIから「無償判定権限」および「無償交換・無償修理権限」を付与された代理店・整備センターのことです。
          </p>
          <p className="text-gray-700 leading-relaxed">
            IDS佐賀教習所（株式会社アイテム）は、この推薦修理センターに認定されており、DJI修理マニュアル・アフターサービスポリシーに基づく高度な修理対応が可能です。
          </p>
        </div>

        {/* 対応可能なこと */}
        <div className="mb-12">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            IDS佐賀教習所が対応可能なこと
          </h3>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white rounded-xl shadow-md p-8">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl font-bold text-blue-600">1</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900">
                  自社販売製品の無償修理
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                IDS佐賀教習所で購入されたDJI製品の、保証期間内の製品起因故障を無償で修理いたします。お客様のご負担はありません。
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-8">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl font-bold text-blue-600">2</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900">
                  他社購入機の無償修理対応
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                他の代理店や二次代理店で購入されたDJI機でも、保証期間内で製品起因の故障であれば、無償修理を実施いたします。DJIから依頼を受けた他社案件にも対応可能です。
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-8">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl font-bold text-blue-600">3</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900">
                  無償修理の費用補填制度
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                無償修理・無償交換にかかる修理工賃および部品費用は、DJI JAPANから推薦修理センターへ補填されるため、お客様のご負担はありません。安心してご依頼ください。
              </p>
            </div>

            <div className="bg-white rounded-xl shadow-md p-8">
              <div className="flex items-center mb-4">
                <div className="w-12 h-12 bg-blue-100 rounded-full flex items-center justify-center mr-4">
                  <span className="text-2xl font-bold text-blue-600">4</span>
                </div>
                <h4 className="text-xl font-bold text-gray-900">
                  飛行データ解析による製品起因判定
                </h4>
              </div>
              <p className="text-gray-700 leading-relaxed">
                墜落や衝突の痕跡がある場合でも、DJIアフターサービスセンターでの飛行データ解析により製品起因と判断された場合は、無償修理の対象となります。
              </p>
            </div>
          </div>
        </div>

        {/* 無償対応の条件 */}
        <div className="grid md:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-xl shadow-md p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              無償対応の条件
            </h3>
            <p className="text-gray-700 mb-6">
              以下の条件を満たす場合、無償修理の対象となります：
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  納品前、または納品からメーカー保証期間内の製品
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  破損、墜落痕、改造痕が無いこと
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  製品起因による故障と判断されること
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  墜落・衝突の痕跡がある場合でも、飛行データ解析により製品起因と判断された場合
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-checkbox-circle-fill text-green-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  DJIから特別に無償対応と指定された現象（保証期間外も含む場合あり）
                </span>
              </li>
            </ul>
          </div>

          <div className="bg-white rounded-xl shadow-md p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              有償修理の対象
            </h3>
            <p className="text-gray-700 mb-6">
              以下の場合は有償修理となります：
            </p>
            <ul className="space-y-3">
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  メーカー保証期間外の製品
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  ユーザー起因の墜落、水没、破損
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  改造痕が認められる製品
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  火災、洪水、強風、落雷など不可抗力による損害
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  被保険者と生計を共にする同居親族への損害
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  戦争、内乱、暴動など社会的混乱による損害
                </span>
              </li>
              <li className="flex items-start">
                <i className="ri-close-circle-fill text-red-600 text-xl mr-3 mt-1"></i>
                <span className="text-gray-700">
                  日本国外で生じた損害
                </span>
              </li>
            </ul>
            <p className="text-gray-700 mt-6 leading-relaxed">
              有償修理の場合も、お見積もりは無料です。まずはお気軽にご相談ください。修理内容と費用を明確にご提示いたします。
            </p>
          </div>
        </div>

        {/* CTA */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/locations#saga"
            className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 text-white font-bold rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-map-pin-line text-xl mr-2"></i>
            IDS佐賀教習所へ相談する
          </Link>
          <button
            onClick={scrollToContact}
            className="inline-flex items-center justify-center px-8 py-4 bg-gray-900 text-white font-bold rounded-lg hover:bg-gray-800 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-mail-line text-xl mr-2"></i>
            修理のお問い合わせ
          </button>
        </div>
      </div>
    </section>
  );
}
